// SPDX-License-Identifier: BUSL-1.1

/**
 * Activity event column definitions for the HB-03 server-side timeline.
 *
 * Extracted from `routes/agent-detail.tsx` during the P3b refactor.
 */

import { type ColumnDef } from '@tanstack/react-table';
import { EVENT_KIND_COLORS, formatTimeAgo, renderEventSummary } from './helpers';
import type { ActivityEvent } from './types';

export const eventColumns: ColumnDef<ActivityEvent>[] = [
  {
    accessorKey: 'kind',
    header: 'Kind',
    cell: ({ row }) => {
      const colors =
        EVENT_KIND_COLORS[row.original.kind] ?? 'bg-neutral-700 text-neutral-300';
      return (
        <span className={`inline-flex rounded px-2 py-0.5 text-xs ${colors}`}>
          {row.original.kind}
        </span>
      );
    },
  },
  {
    id: 'summary',
    header: 'Summary',
    cell: ({ row }) => (
      <span className="text-sm text-neutral-300" title={JSON.stringify(row.original.payload)}>
        {renderEventSummary(row.original)}
      </span>
    ),
  },
  {
    accessorKey: 'occurredAt',
    header: 'When',
    cell: ({ row }) => (
      <span className="text-neutral-400" title={new Date(row.original.occurredAt).toLocaleString()}>
        {formatTimeAgo(row.original.occurredAt)}
      </span>
    ),
  },
];
